/**
 * Scroll to a specified selector
 * @param {HTMLElement} element
 * @param {number} offset
 * @param {Function} callback
*/

export default (element, offset = 0, callback = () => {}) => {
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    let offsetPosition = elementPosition - (offset * -1);
    const offsetPositionFixed = offsetPosition.toFixed();
    let scrollTime = 0;
    let cancelled = false;

    const callScrollToSelectorCallback = () => {
        if (window.pageYOffset.toFixed() === offsetPositionFixed) {
            window.removeEventListener('scroll', callScrollToSelectorCallback);
            cancelled = true;
            callback();
        } else {
            const currentScrollTime = new Date().getTime();
            scrollTime = currentScrollTime;

            setTimeout(() => {
                if (!cancelled && currentScrollTime === scrollTime) {
                    window.removeEventListener('scroll', callScrollToSelectorCallback);
                    callback();
                }
            }, 150);
        }
    };

    if (typeof callback === 'function') {
        window.addEventListener('scroll', callScrollToSelectorCallback);
        callScrollToSelectorCallback();
    }

    setTimeout(() => {
        if (offsetPosition === 0) {
            offsetPosition = -1;
        }

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    }, 10);
};
